<template>
  <div class="m-0 dbozone-font bg-blessingtiger" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-blessingtiger">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -blessingtiger`">{{ $t('3_5_bonus_20.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4 nav-special-symbols">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_8.png`)"
          alt="">
        </div>
        <div class="col-9 align-items-center p-0 d-flex ml-2 justify-content-center">
          <span class="font-weight-bold text-sub" :class="`-${lang} -wild`">
            {{$t('blessingtiger.scatter-desc')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4 nav-special-symbols">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_9.png`)"
          alt="">
        </div>
        <div class="col-9 align-items-center p-0 d-flex ml-2 justify-content-center">
          <span class="font-weight-bold text-sub" :class="`-${lang} -wild`">
            {{$t('main-game.wild1')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_7.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[7][4]}}<br>
            {{'4 - ' + paytable[7][3]}}<br>
            {{'3 - ' + paytable[7][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_6.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[6][4]}}<br>
            {{'4 - ' + paytable[6][3]}}<br>
            {{'3 - ' + paytable[6][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_5.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[5][4]}}<br>
            {{'4 - ' + paytable[5][3]}}<br>
            {{'3 - ' + paytable[5][2]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[4][4]}}<br>
            {{'4 - ' + paytable[4][3]}}<br>
            {{'3 - ' + paytable[4][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[3][4]}}<br>
            {{'4 - ' + paytable[3][3]}}<br>
            {{'3 - ' + paytable[3][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[2][4]}}<br>
            {{'4 - ' + paytable[2][3]}}<br>
            {{'3 - ' + paytable[2][2]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-left d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[1][4]}}<br>
            {{'4 - ' + paytable[1][3]}}<br>
            {{'3 - ' + paytable[1][2]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_0.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[0][4]}}
            <br>{{'4 - ' + paytable[0][3]}}
            <br>{{'3 - ' + paytable[0][2]}}
          </span>
        </div>
      </div>

      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('main-game.wild1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.wild2') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-blessingtiger mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -blessingtiger`">{{ $t('blessingtiger.gold-framed-symbol.title') }}</h5>
        </section>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/blessingtiger/gold_framed_symbols.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.gold-framed-symbol.desc1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.gold-framed-symbol.desc2') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-blessingtiger mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -blessingtiger`">{{ $t('blessingtiger.multiplier.title') }}</h5>
        </section>c
      </div>

      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.multiplier.desc1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.multiplier.desc2') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.multiplier.desc3') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.multiplier.desc4') }}</li></span>
      </div>
      <div class="d-flex flex-column nav-blessingtiger mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -blessingtiger`">{{ $t('blessingtiger.freespin.title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="col-3 justify-content-center d-flex flex-row">
            <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_8.png`)"
            alt="">
        </div>
        <div class="col-3 justify-content-center d-flex flex-row">
            <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_8.png`)"
            alt="">
        </div>
        <div class="col-3 justify-content-center d-flex flex-row">
            <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_8.png`)"
            alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.freespin.desc1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 freespin-reel" :src="require(`../../assets/paytable/blessingtiger/freespin_reel.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.freespin.desc2') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.freespin.desc3') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.freespin.desc4') }}</li></span>
      </div>

      <div class="d-flex flex-column nav-blessingtiger mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -blessingtiger`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/blessingtiger/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.featurebuy.text1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('blessingtiger.featurebuy.text2') }}</li></span>
      </div>

      <div class="d-flex flex-column nav-blessingtiger mt-4 mb-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -blessingtiger`">{{ $t('blessingtiger.way.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('blessingtiger.way.desc1') }}</li></span>
      </div>
      <div class="justify-content-center d-flex flex-col">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/blessingtiger/line_paytable.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('blessingtiger.way.desc2') }}</li></span>
      </div>
      <div class="d-flex flex-col p-2 mb-1 justify-content-center">
        <span class="m-0  text-sub">{{ $t('blessingtiger.way.from-above-example') }}</span>
      </div>
      <div class="d-flex p-2 mb-1 justify-content-center">
        <span class="m-0  text-sub text-sub-yellow">{{ $t('blessingtiger.way.from-above-example-desc') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('blessingtiger.way.desc3') }}</li></span>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 mt-2">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/blessingtiger/way.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center ml-2">
          <span class="text-sub" :class="`-${lang}`">
            {{$t('blessingtiger.way.win5')}} <br>
            {{$t('blessingtiger.way.win4')}} <br>
            {{$t('blessingtiger.way.win3')}}
          </span>
        </div>
        <div class="d-flex flex-column">
          <div class="p-0 justify-content-center d-flex">
            <span class="m-0 text-sub text-sub-gov justify-content-center">{{ $t('blessingtiger.way.total-winning') }}</span>
          </div>
          <div class="p-0 justify-content-center d-flex">
            <span class="m-0 text-sub text-sub-yellow justify-content-center">{{ $t('blessingtiger.way.total-winning-desc') }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('blessingtiger.way.desc4') }}</li></span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('blessingtiger.way.desc5') }}</li></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-blessingtiger',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}

.freespin-reel {
  width: 100%;
}

.nav-special-symbols {
  border-color: #98134D;
  border-style: solid;
  border-radius: 15px;
  border-width: thick;
}

.desc-text {
  font-size: 42px;
  color: #fff;
}

.content {
  background: #000013;
  height: 100%;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.span {
  text-align: justify;
  text-justify: inner-word;
}

.text-sub-yellow {
  color: #FFE600;
}

.text-sub-gov {
  text-align: center;
}

.text-sub.-wild {
  text-align: center;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;  
  }
}

</style>